import React from 'react';
import { Skeleton } from './Skeleton';
import './StatCard.css';

/**
 * StatCard — одна карточка с цифрой вместо 7 вариантов (аудит U4).
 *
 *   label  — подпись сверху, обычным регистром («Отгружено сегодня»)
 *   value  — число/строка; число форматируется с разрядами (1 427), null → «—»
 *   unit   — единица после числа мелко («шт», «₽»)
 *   hint   — строка-пояснение под числом («из 1 655 по плану»)
 *   tone   — 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'accent':
 *            цвет точки у подписи и цифры; без полос, рамок и заливок
 *   icon   — иконка lucide справа от подписи (приглушённая), по желанию
 *   onClick / active — карточка-фильтр: кликается, активная подсвечена рамкой
 *   loading — скелетон вместо цифры
 *   size   — 'md' (24 px) | 'sm' (20 px, плотные ряды и ТСД)
 */
export function StatCard({
  label,
  value,
  unit,
  hint,
  tone = 'neutral',
  icon: Icon,
  onClick,
  active = false,
  loading = false,
  size = 'md',
  className = '',
  title,
}) {
  const clickable = typeof onClick === 'function';
  const shown = value === null || value === undefined || value === ''
    ? '—'
    : (typeof value === 'number' ? value.toLocaleString('ru-RU') : value);
  const Tag = clickable ? 'button' : 'div';
  return (
    <Tag
      type={clickable ? 'button' : undefined}
      className={[
        'ui-stat', `ui-stat--${tone}`, `ui-stat--${size}`,
        clickable && 'ui-stat--clickable', active && 'ui-stat--active', className,
      ].filter(Boolean).join(' ')}
      onClick={onClick}
      aria-pressed={clickable ? active : undefined}
      title={title}
    >
      <span className="ui-stat__head">
        {tone !== 'neutral' && <span className="ui-stat__dot" aria-hidden="true" />}
        <span className="ui-stat__label">{label}</span>
        {Icon && <Icon size={16} className="ui-stat__icon" aria-hidden="true" />}
      </span>
      <span className="ui-stat__value">
        {loading ? <Skeleton width="60%" height={size === 'sm' ? 20 : 24} /> : shown}
        {!loading && unit && shown !== '—' && <span className="ui-stat__unit">{unit}</span>}
      </span>
      {hint && <span className="ui-stat__hint">{hint}</span>}
    </Tag>
  );
}
